export default "__VITE_ASSET__COzVvqhz__"